import { YourFeedback } from "@/app/components/common/actions/inputs-b/YourFeedbackText";

export default function ReportIssuse({
  setReport,
  report,
}: {
  setReport: (value: string) => void;
  report: string;
}) {
  const handleReportChange = (value: string) => {
    setReport(value);
  };

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12">
        <YourFeedback
          label="Description"
          value={report}
          onChange={handleReportChange}
        />
      </div>
    </div>
  );
}
